import React from 'react'

export  function InvoiceDetail() {
    return (
            
        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            {/* <div className="col-md-12 my-4">
                                <h3 className="mb-3 d-flex align-items-center"><b>OnlinePaymentRegister ID - 000771/130421/US  </b> <img className="shareicon" src="/admin/assets/images/share_icon.svg" height="20" /></h3>
                                <p className="text-muted">Advance paid - 0.00 AED</p>
                            </div> */}
                           
                            <div className="col-12">
                                <hr />
                            </div>
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 border-end">

                                            {/* <h5 className="secHeading">Warehouse Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                <tr>
                                                        <td className="py-1">Date -  </td>
                                                        <td className="py-1">15 May, 2021	</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Booking Ref# - </td>
                                                        <td className="py-1">#5418515</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Invoice Ref#  - </td>
                                                        <td className="py-1">#5655163</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Invoice Amount - </td>
                                                        <td className="py-1">AED 5689.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Adjusted Amount - </td>
                                                        <td className="py-1">AED 5689.00</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Balance Due </td>
                                                        <td className="py-1">AED 5689.00</td>
                                                    </tr>
                                                    
                                                  
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                       
                    </div >
                </div >
            </div >
        </div >
)
}
